import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type ProductVariantsPriceIndexSignalsCount as SchemaProductVariantsPriceIndexSignalsCount } from '../schemas/ProductVariantsPriceIndexSignalsCount';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Products
 */
export const GetProductVariantsPriceIndexSignalsCountContentType = '' as const;
export type GetProductVariantsPriceIndexSignalsCountRequest = void;
export type GetProductVariantsPriceIndexSignalsCountResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of data
     */
    '200': {
        'application/json': SchemaProductVariantsPriceIndexSignalsCount;
    };
};
export type GetProductVariantsPriceIndexSignalsCountResponseSuccess =
    GetProductVariantsPriceIndexSignalsCountResponses['200']['application/json'];
export type GetProductVariantsPriceIndexSignalsCountSearchParams = undefined;
export type GetProductVariantsPriceIndexSignalsCountPathParameters = undefined;
export const GetProductVariantsPriceIndexSignalsCountUrl = '/counts/price-index-signals' as const;
export const GetProductVariantsPriceIndexSignalsCountMethod = 'GET' as const;
export const getGetProductVariantsPriceIndexSignalsCountUrl = (
    _params?: GetProductVariantsPriceIndexSignalsCountPathParameters
) => GetProductVariantsPriceIndexSignalsCountUrl;
